"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.996 14.873c-1.557 0-3.115.004-4.672-.001-.64-.002-1.117-.3-1.386-.88-.274-.59-.212-1.163.208-1.674.11-.134.252-.243.388-.354a1.61 1.61 0 0 0 .626-1.31c0-.92-.018-1.84.004-2.76.046-1.966.935-3.441 2.67-4.365 1.71-.91 3.883-.621 5.332.668 1.111.989 1.67 2.234 1.678 3.723q.005 1.355 0 2.71c-.001.545.198.995.63 1.333.297.232.554.49.675.863a1.552 1.552 0 0 1-1.47 2.047c-1.561.003-3.122 0-4.683 0m-.008-1.372h4.647c.095 0 .172-.021.204-.118.032-.092.002-.168-.075-.227l-.152-.123q-1.136-.926-1.139-2.39c-.001-.895.006-1.79-.004-2.686a4.5 4.5 0 0 0-.074-.79c-.324-1.736-2.032-2.98-3.782-2.766a3.5 3.5 0 0 0-3.081 3.478c0 .957.004 1.913-.003 2.87a2.76 2.76 0 0 1-.628 1.765c-.189.233-.427.425-.648.63-.1.094-.138.193-.063.274a.3.3 0 0 0 .2.078q2.3.006 4.598.004m.025 3.499c-.454 0-.907.003-1.36-.001-.399-.003-.702-.282-.72-.655a.68.68 0 0 1 .676-.717c.33-.005.662-.001.993-.001q.894-.002 1.789.001a.68.68 0 0 1 .678.588.684.684 0 0 1-.479.749 1 1 0 0 1-.278.034c-.433.004-.866.002-1.3.002"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertIcon20.js.map